import React from 'react';
import { List } from 'antd';
import { css } from '@emotion/css';
import { SingleList } from '@appbaseio/reactivesearch';

const listItems = css`
	margin: 20px 10px !important;
	width: 280px;
	border: 1px solid #eaeaea !important;
	max-height: 250px;
	overflow-x: hidden;
	overflow-y: scroll !important;
	font-size: 0.9rem !important;
	@media (max-width: 576px) {
		margin: 20px 0px !important;
		padding: 0 10px 10px !important;
	}

	.ant-list-header {
		padding: 5px !important;
		position: sticky;
		top: 0;
		background: white;
		box-shadow: 0 2px 5px -1px #f5f5f5;
		z-index: 10;
		.title {
			margin: 0;
			padding: 0 5px;
			font-size: 1rem;
			font-weight: 500;
			color: #424242;
		}
	}

	.selected {
		.ant-list-item-meta-title {
			color: #174ff4 !important;
		}
		pointer-events: none;
		&:hover {
			background: inherit;
		}
	}

	.ant-list-item {
		border: 0 !important;
		padding: 5px 0 !important;
		cursor: pointer;
		&:hover {
			background: #eaeaea !important;
		}
	}

	.ant-list-item-meta-title {
		padding: 0 10px !important;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 270px;
		white-space: nowrap;
	}

	.ant-list-item-meta-title,
	.ant-list-item-meta {
		margin: 0 !important;
	}
`;

/*
	This component can be used inside ReactiveComponent to generate an UI for
	SingleList using List Component of Ant Design.

	You can modify this component for MultiList by tracking multiple values in
	state.
*/

class ListComponent extends React.Component {
	componentDidUpdate(prevProps) {
		const { selectedValue } = prevProps;
		const { selectedValue: newValue, setQuery, dataField } = this.props;

		if (newValue !== selectedValue) {
			const query = SingleList.defaultQuery(newValue, {
				queryFormat: 'or',
				dataField,
			});
			setQuery({
				query,
				value: newValue,
			});
		}
	}

	handleChange = selectedItem => {
		const { setQuery, dataField } = this.props;
		const query = SingleList.defaultQuery(selectedItem, {
			queryFormat: 'or',
			dataField,
		});
		setQuery({
			query,
			value: selectedItem,
		});
	};

	render() {
		const { selectedValue } = this.props;
		const { dataField, dataKey, title, listComponentProps, aggregations } = this.props;
		let items = [];
		if (aggregations && aggregations[dataField] && aggregations[dataField].buckets.length) {
			/* eslint-disable camelcase */
			items = aggregations[dataField].buckets.map(({ key: itemKey, doc_count }) => ({
				value: itemKey,
				count: doc_count,
			}));
			/* eslint-enable camelcase */
			items = items.filter(({ value }) => value !== '');
		}

		return (
			<React.Fragment>
				<List
					key={dataKey}
					itemLayout="vertical"
					header={<h2 className="title">{title}</h2>}
					dataSource={items}
					bordered={false}
					className={listItems}
					renderItem={item =>
						item.value === selectedValue ? (
							<List.Item className="selected">
								<List.Item.Meta title={item.value} />
							</List.Item>
						) : (
							<List.Item onClick={() => this.handleChange(item.value)}>
								<List.Item.Meta title={item.value} />
							</List.Item>
						)
					}
					{...listComponentProps}
				/>
			</React.Fragment>
		);
	}
}

export default ListComponent;
